import { render, staticRenderFns } from "./ProjectHdds.vue?vue&type=template&id=860cc4d2"
import script from "./ProjectHdds.vue?vue&type=script&lang=ts"
export * from "./ProjectHdds.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports